<div>

  <div>
    <button (click)="show=true" style="margin-right:10px;">Show</button>
    <button (click)="show=false">Hide</button>

  </div>

  <div [ngShow]="show">

    <h2>We have created custom `ngShow` directive to show hide this text. </h2>

  </div>

</div>
